import { useContext, useEffect, useState } from 'react'
import DynamicDownloadBtnSection from '../../../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection'
import "./Aqars.scss";
import { AppContext } from '../../../../context/AppContext';
import { toast } from 'react-toastify';
import axios from 'axios';

const Aqars = () => {

    const { backendUrl } = useContext(AppContext);
    const [allAqars, setAllAqars] = useState([]);
     let errorShown = false;

       async function fetchAllAqars() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllAqars`);
            if (data.success) {
                setAllAqars(data || []);
            } 
            errorShown = false;  
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
            if (error.response && error.response.status === 503) {
                            toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                        }
                        else if (!navigator.onLine) {
                            toast.error("🚫 No internet connection. Please check your network.");
                        }
            
                        else if (error.request && !error.response) {
                            toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                        }
                        else 
                        {
                            console.error("Unexpected error:", error);
                            toast.error("Something went wrong.");
                        }
        }
    }

    useEffect(() => {
        fetchAllAqars();
    }, []);

    const content = allAqars?.reports
        ?.filter(item => item.isActive)
        .map(item => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];

    return (
        <section className="aqarsMainContainer">
            <header className="aqarsHeader">
                <h2>AQARS</h2>
            </header>
            <DynamicDownloadBtnSection
                items={content}
                yearFontSize={1.25}
            />
        </section>
    )
}

export default Aqars
